import { MockedRequest, RestHandler, rest } from "msw";

import { ClientConfig } from "app/clientConfig";
import { BASE_CLIENT_CONFIG } from "app/clientConfig/baseConfig";

import { ErrorResponse } from "../../types/ErrorResponse";

export const getClientConfigHandler = (
  status: number,
  response: ClientConfig | ErrorResponse
): RestHandler<MockedRequest<ClientConfig | null>> => {
  return rest.get(`/app-config/:clientId`, (_req, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const clientConfigHandlers = [getClientConfigHandler(200, BASE_CLIENT_CONFIG)];
